import { TablePlaceFilterInput } from 'common/inputs/TablePlaceFilterInput'
import { MantineReactTable, type MRT_ColumnDef } from 'mantine-react-table'
import { useMemo } from 'react'
import { Category, Place, TableType, TableVariant } from 'types/products'
import { useTableWithProduct, VariantWithProduct } from './useTableWithProduct'

export function TableTableWithProduct() {
  const columns = useMemo<Array<MRT_ColumnDef<VariantWithProduct<TableVariant>>>>(
    () => [
      {
        accessorKey: 'product.symbol',
        header: 'Produkt',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po symbolu',
        },
      },
      {
        accessorKey: 'tableType',
        header: 'Rodzaj',
        size: 100,
        Cell: ({ cell }) => {
          const tableType = cell.getValue<TableType>()
          switch (tableType) {
            case TableType.TABLECLOTH:
              return 'Obrus'
            case TableType.TABLE_RUNNER:
              return 'Bieżnik'
            case TableType.NAPKIN:
              return 'Serwetka'
            default:
              return 'Nieznany rodzaj'
          }
        },
        filterVariant: 'select',
        mantineFilterSelectProps: {
          data: Object.values(TableType).map((place) => ({
            value: place,
            label: place === TableType.TABLECLOTH ? 'Obrus' : place === TableType.TABLE_RUNNER ? 'Bieżnik' : 'Serwetka',
          })),
        },
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po rodzaju',
        },
      },
      {
        accessorKey: 'size',
        header: 'Wymiar',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po wymiarze',
        },
      },
      {
        accessorKey: 'stock',
        header: 'Ilość sztuk',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po ilości',
        },
      },
      {
        accessorKey: 'place',
        header: 'Półka',
        enableSorting: false,
        size: 100,
        Cell: ({ cell }) => {
          const place = cell.getValue<Place>()
          return `${place.rack}-${place.column}-${place.shelf}`
        },
        Filter: TablePlaceFilterInput,
      },
      {
        accessorKey: 'feature',
        header: 'Cecha',
        enableSorting: false,
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po cesze',
        },
      },
      {
        accessorKey: 'comments',
        header: 'Uwagi',
        enableSorting: false,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po uwagach',
        },
      },
    ],
    []
  )

  const table = useTableWithProduct({
    category: Category.TABLE,
    columns,
  })

  return <MantineReactTable table={table} />
}
